<mat-card appCard style="box-shadow: 0px 6px 22px -8px rgba(0, 0, 0, 0.2)">
    <mat-card-header class="titree">
        {{ info_gen | translate }}
    </mat-card-header>
    <mat-card-content class="card-content">
        <table [dataSource]="dataSource" mat-table style="width: 100%;">

            <ng-container matColumnDef="label" sticky="true">
                <td *matCellDef="let row" mat-cell>{{ row.label  | translate }}</td>
            </ng-container>

            <ng-container *ngFor="let column of dataa; let i = index" [matColumnDef]="'column' + i">
                <td *matCellDef="let row" mat-cell>
                    <span *ngIf="row.label!='Catégorie Activité'">  {{ row['column' + i]  |typedValue|async| translate }} </span>
                    <ng-container *ngIf="row.label=='Catégorie Activité'">
                        <div *ngFor="let check of list; let i = index" class="cp5" fxLayout="row wrap"
                             fxLayoutAlign="flex-start center">

                            <div fxFlex="33" fxFlex.lt-md="100">
                                <mat-checkbox [(ngModel)]="check.exist" [disabled]="true"

                                >{{ check.cdNmFr | translate }}
                                </mat-checkbox>
                            </div>
                            <!-- <div  fxFlex="33"  fxFlex.lt-md="100">
                              <mat-checkbox [disabled]="true"

                          >{{ "Fourniture Bien" | translate }}
                          </mat-checkbox>
                            </div>
                            <div  fxFlex="33"  fxFlex.lt-md="100">
                              <mat-checkbox [disabled]="true"

                          >{{ "Fourniture Services" | translate }}
                          </mat-checkbox>
                            </div>

                            <div  fxFlex="33"  fxFlex.lt-md="100">
                              <mat-checkbox [disabled]="true"

                          >{{ "Etudes" | translate }}
                          </mat-checkbox>
                            </div> -->

                        </div>
                    </ng-container>

                </td>

            </ng-container>


            <tr *matRowDef="let row; columns: displayedColumns;" mat-row></tr>
        </table>
        <app-empty-list-container [list]="dataSource.data" [withoutBorder]="true"></app-empty-list-container>
    </mat-card-content>
</mat-card>
